// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"45db5cb6","249":"a74250c5","396":"e0240847","655":"493e975e","831":"1ab88520","981":"c697e49d"}[chunkId] + ".chunk.css";
};